module.exports = __webpack_public_path__ + "img/eye.6e128c30.svg";